import axios from 'axios';
import generateToken from '../generateToken';

export default async function Decrypt(email, config) {
  const { endpoints } = config;
  const decryptEndpoint = `${endpoints.utilsApi}/decrypt`;

  try {
    const tokenResponse = await generateToken(config);
    const token = tokenResponse?.data?.token;

    if (token) {
      return axios({
        url: decryptEndpoint,
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-authenticate-token': `Bearer ${token}`,
        },
        data: { cipher: email },
      })
        .then(response => response.data)
        .catch(error => {
          console.error('Error in the Decrypt service: ', error);
          return error;
        });
    }
    return undefined;
  } catch (error) {
    console.error('Error at email decryption: ', error);
    return undefined;
  }
}
